import { XButton, XGrid, XIcon } from '@orderx/lab/ui';
import React from 'react';
import { SpcCheckoutHeader } from '../header/SpcCheckoutHeader';
import { Course } from '../../../XV2';
import './SpcCheckoutChangeCourse.scss';
import { OrderProductRequestStatus } from '../../../XV2';
import { useToggle } from '../../../hooks/toggle';

type SpcCheckoutChangeCourseInput = {
    response: {
        totalCost: number;
        courses: Pick<Course, 'id' | 'name'>[];
        courseOrderProducts: {
            orderProductId: number;
            productName: string;
            courseId: number;
        }[];
    };
    isLoading: boolean;
    onNext(data: any): void;
    onClose(): void;
};

export function SpcCheckoutChangeCourse({ response, onNext, isLoading, onClose }: SpcCheckoutChangeCourseInput) {
    const { totalCost, courseOrderProducts } = response;
    const [isRightAway, toggleIsRightAway] = useToggle();

    //const getProductCourses = () => {
    //    const productCourses = {};
    //
    //    courseOrderProducts.forEach((item) => {
    //        productCourses[item.orderProductId] = item.courseId;
    //    });
    //
    //    return productCourses;
    //};

    function handleNext() {
        if (isRightAway) {
            handleRightAway();
        } else {
            handleAtRightCourse();
        }
    }

    function handleRightAway() {
        const productRequestStatus = {};

        courseOrderProducts.forEach(({ orderProductId }) => {
            productRequestStatus[orderProductId] = OrderProductRequestStatus.REQUEST;
        });

        onNext({ productRequestStatus });
    }

    function handleAtRightCourse() {
        onNext({});
    }

    return (
        <>
            <SpcCheckoutHeader totalCost={totalCost} onClose={onClose} />

            <XGrid className={'SpcCheckoutChangeCourse'}>
                <div>How do you want your food served?</div>

                <XButton
                    onClick={toggleIsRightAway}
                    className={'check'}
                    color={isRightAway ? 'secondary' : 'default'}
                    variant={isRightAway ? 'outlined' : 'filled'}>
                    <XIcon>{isRightAway ? 'task_alt' : 'radio_button_unchecked'}</XIcon>
                    <div>I want all items served at once</div>
                </XButton>

                <XButton onClick={handleNext} isLoading={isLoading} color={'primary'} className={'cta'}>
                    Next
                </XButton>
            </XGrid>
        </>
    );
}
